import React from 'react'
import { sanitySrcUrl } from '../../lib/libFunctions'
import { imageStyles } from '../../styles/base/_allBase.styles'
import { CustomButton } from '../button/button.component'
import { analyticsModuleAttributes } from '../../lib/analytics-content.mjs'
import { Hero, HeroInner, HeroCopy, HeroImage } from './section-one.styles'
const { ImgCover } = imageStyles

export default function SectionOne({ header, variant = 'guide', ctaHref = null, ctaLabel, ctaExternal = false }) {
  return (
    <Hero $variant={variant} {...analyticsModuleAttributes(header, 'hero', 0, header?.header)}>
      <HeroInner $hasImage={Boolean(header?.photo)}>
        <HeroCopy $variant={variant}>
          <h1>{header?.header}</h1>
          {header?.subheader && <p>{header.subheader}</p>}
          {ctaHref && ctaLabel && <CustomButton href={ctaHref} external={ctaExternal}
            data-analytics-cta-id={`${header?._key || 'hero'}-cta`}
            data-analytics-cta-label={ctaLabel} data-analytics-placement-id="hero">{ctaLabel}</CustomButton>}
        </HeroCopy>
        {header?.photo && <HeroImage $variant={variant}>
          <ImgCover src={header.photoOverride?.src || sanitySrcUrl(header.photo)} alt={header.photoOverride?.alt || header.photo.alt || ''} fill priority={variant === 'destination'} sizes="(max-width: 767px) 100vw, 50vw" />
        </HeroImage>}
      </HeroInner>
    </Hero>
  )
}
